import { getCookie, setCookie } from '../utils/cookie';
import ready from '../utils/ready';

const cookieConsentButton = 'cookie-consent';

const initializeCookieConsent = () => {
  const cookieBar = document.getElementById('cookie-consent-banner');
  if (cookieBar) {
    const hasConsent = getCookie(cookieConsentButton);
    if (!hasConsent) {
      document.getElementById('cookie-consent-banner-confirm')?.addEventListener('click', () => {
        setCookie(cookieConsentButton, true, 365 * 10);
        cookieBar.setAttribute('hidden', '');
      });
      cookieBar.removeAttribute('hidden');
    }
  }
};

ready(initializeCookieConsent);
